<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12">
          <div class="d-flex flex-wrap flex-gap align-center">
            <v-checkbox v-model="useSms" class="mt-0" label="Sử dụng SMS" hide-details></v-checkbox>
            <v-checkbox v-model="useApp" class="mt-0" label="Sử dụng APP" hide-details></v-checkbox>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="phone"
            label="SĐT đăng ký"
            return-object
            clearable
            flat
            outlined
            hide-details
            dense
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="dadPhone"
            label="SĐT Bố"
            clearable
            flat
            outlined
            hide-details
            dense
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="momPhone"
            label="SĐT Mẹ"
            clearable
            flat
            outlined
            hide-details
            dense
            @keyup.enter="onFilterChanged"
          />
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="dadName"
            label="Họ tên Bố"
            clearable
            flat
            outlined
            hide-details
            dense
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="momName"
            label="Họ tên Mẹ"
            clearable
            flat
            outlined
            hide-details
            dense
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="selectedStatus"
            item-text="title"
            item-value="status"
            label="Trạng thái"
            :items="statuses"
            outlined
            clearable
            dense
            hide-details
          ></v-select>
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: { GradeClassStudentSelect },
  data: () => ({
    useSms: false,
    useApp: false,
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    phone: '',
    dadPhone: '',
    momPhone: '',
    dadName: '',
    momName: '',
    selectedStatus: '',
    statuses: [
      {
        title: 'Chưa cài đặt',
        status: 'inactive'
      },
      {
        title: 'Đã khoá',
        status: 'locked'
      },
      {
        title: 'Hoạt động',
        status: 'active'
      }
    ]
  }),
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      let params = {
        contactBookApp: this.useApp,
        contactBookSms: this.useSms
      }
      if (get(this.selectedStudent, 'id', '')) {
        params.id = get(this.selectedStudent, 'id')
      } else {
        if (get(this.selectedClass, 'id', '')) {
          params.currentClass = get(this.selectedClass, 'id')
        } else {
          if (get(this.selectedGrade, 'id', '')) {
            params.grade = get(this.selectedGrade, 'id')
          }
        }
      }
      if (this.phone) {
        params.contactBookPhones_contains = this.phone
      }
      if (this.dadPhone) {
        params.dadPhone = this.dadPhone
      }
      if (this.momPhone) {
        params.momPhone = this.momPhone
      }
      if (this.dadName) {
        params.dadName_contains = this.dadName
      }
      if (this.momName) {
        params.momName_contains = this.momName
      }

      if (this.useApp) {
        params = {
          ...params,
          _where: {
            _or: [{ fcmAndroid_null: false }, { fcmIos_null: false }]
          }
        }
      }
      if (this.selectedStatus === 'inactive') {
        params['contactBook_null'] = true
        params['_sort'] = 'createdAt:desc'
      } else {
        if (this.selectedStatus) {
          params['contactBookStatus'] = this.selectedStatus
        }
        params['_sort'] = 'nameToNumber:ASC,index:ASC'
      }
      params['status'] = 'active'

      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-gap {
  gap: 24px;
}
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
